import { render, staticRenderFns } from "./ReceiverLocationListDataTable.vue?vue&type=template&id=611c1d8f&"
import script from "./ReceiverLocationListDataTable.vue?vue&type=script&lang=js&"
export * from "./ReceiverLocationListDataTable.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverLocationListDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports